const HasFeature = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$hasFeature', { 
      // eslint-disable-next-line object-shorthand
      value: function (value) {
        if (!this.$store?.state?.user?.user?.features) return false;
        const feature = this.$store.state.user.user.features.find(f => f.toLowerCase() == value.toLowerCase());
        return (!!feature);
      } 
    });
  }
}
export default HasFeature;
